import React from 'react';
import PropTypes from 'prop-types';

import { getUserId } from '../../../utils/functions';
import { MOD_VERSION_STATUS } from '../../../utils/constants';

import Caption from '../../Caption/Caption';
import EditLabelError from '../../Edit/EditLabelError/EditLabelError';
import TitleDialog from '../../TitleDialog/TitleDialog';
import Select from '../../Select/Select';
import { ButtonBlueLarge } from '../../Buttons/ButtonBlueLarge/ButtonBlueLarge';
import Alert from '../../Alert/Alert';

import { 
    CHANGE_GAME_VERSION_MAIN_TITLE,
    SELECT_GANE_VERSION_TITLE,
    DIALOG_CHANGE_GAME_VERSION_ALERT,
    DIALOG_CHANGE_GAME_VERSION_ATTENTION,
    DIALOG_CHANGE_GAME_VERSION_BUTTON_EDIT,
} from './translations';

import styles from './DialogChangeGameVersionMod.module.css';

export default class DialogChangeGameVersionMod extends React.Component {
    static propTypes = {
        ownerId: PropTypes.number,
        realm: PropTypes.string,

        id: PropTypes.number,
        //versions: 
        modId: PropTypes.number,
        modVersionId: PropTypes.number,

        onComponentWillMount: PropTypes.func,
        onShowDialogError: PropTypes.func,
        onSubmitDialog: PropTypes.func,
    }

    constructor() {
        super()

        this.state = {
            errorMessage: null,
            isErrorProblemType: false,

            gameVersionId: null,
            gameVersion: null,
        }
    }

    componentDidMount() {
        //this.props.onComponentWillMount(this.props.ownerId)
        
        const selectedVersion = window.__SETTINGS__.gameVersions.find((item) => (item.id === this.props.id))
        this.setState({
            gameVersionId: this.props.id,
            gameVersion: selectedVersion.version, // caption
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        /*if (nextProps.user.readOnly) { // nextProps.data.roExpires
            this.setState({
                ro_expires: nextProps.user.roExpires,
                isBoxChecked: true,
                isBoxDisabled: false,
            })
        }

        if (nextProps.user.role) {
            let userRole = [];
            userRole.push(ROLE_CATEGORIES.find(el => el.value === nextProps.user.role).id)

            this.setState({
                typeIds: userRole,
                isCheckedAll: userRole.length >= MAX_ITEMS_TO_CHECK,
                isErrorProblemType: false,
            })
        }*/

        /*if (nextProps.user.role === "admin" || nextProps.user.role === "robot") {
            this.setState({
                isBoxChecked: false,
                isBoxDisabled: true,
            })
        }*/
    }

    renderErrorMessage() {
        return this.state.errorMessage ? (
            <div className={styles.fileError}>
                <EditLabelError message={this.state.errorMessage} />
            </div>
        ) : null
    }

    handleSaveClick = () => {
        let errorMessage = null
        let hasError = false

        if (this.state.gameVersionId === null || this.state.gameVersion === null) {
            errorMessage = 'Не выбрана версия игры';
            this.setState({
                isErrorProblemType: true,
                errorMessage,
            })
            hasError = true
        }

        if (hasError) {
            return
        }

        const data = { 
            ...this.state, 
            modId: this.props.modId,
            modVersionId: this.props.modVersionId,
            adminId: getUserId() 
        }
        this.props.onSubmitDialog(data)
    }

    handleGameVersionChange =(gameVersionId, gameVersionItems) => {
        const selectedVersion = gameVersionItems.find((item) => (item.value === gameVersionId))
        this.setState({
            gameVersionId,
            gameVersion: selectedVersion.caption,
        })
    }

    renderAlert() {
        return this.state.gameVersionId !== this.props.lastGameVersionId ? (
            <Alert content={DIALOG_CHANGE_GAME_VERSION_ALERT} />
        ) : null
    }

    render() {
        const numberOfPublishedVersions = this.props.versions.filter(
            (item) => item.status === MOD_VERSION_STATUS.PUBLISHED,
        ).length
        
        return (
            <div className={styles.base}>
                <TitleDialog>{CHANGE_GAME_VERSION_MAIN_TITLE}</TitleDialog>
                <div className={styles.modVersion}>
                    <Caption>{SELECT_GANE_VERSION_TITLE}</Caption>
                    <div className={styles.select}>
                        <Select
                            items={this.props.versions}
                            selectedValue={this.state.gameVersionId} // this.state.gameVersionId   this.props.id
                            onItemChange={(selectedGameVersionId) => this.handleGameVersionChange(selectedGameVersionId, this.props.versions)}
                            isDisabled={this.props.versions.length === 1}
                            isChangeGameVersionMod={true}
                            zIndex={numberOfPublishedVersions} /* numberOfPublishedVersions-index */
                        />
                    </div>
                </div>
                {this.renderAlert()}
                <hr className={styles.hr} />
                <p className={styles.attention}>{DIALOG_CHANGE_GAME_VERSION_ATTENTION}</p>
                <ButtonBlueLarge onClick={this.handleSaveClick} gtmTag={'ev_click-change-game-version-mod'}>
                    {DIALOG_CHANGE_GAME_VERSION_BUTTON_EDIT}
                </ButtonBlueLarge>
            </div>
        )
    }
}
